import { render, staticRenderFns } from "./About.vue?vue&type=template&id=076c3648&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=076c3648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c3648",
  null
  
)

export default component.exports